import { useCallback, useContext } from "react";
// import styled from "styled-components";

import { Context } from "../contexts/Modals";
import TxConfirmModal, { txStatus } from "../components/TxConfirmModal";

export default function useTxModal() {
  const { onTxModalPresent, onTxModalDismiss } = useContext(Context);

  const open = useCallback(
    (props: { status?: txStatus; message?: string; title?: string }) => {
      const { status, message, title } = props;
      // console.log("open status, message:", status, message);
      onTxModalPresent(
        <TxConfirmModal
          onDismiss={onTxModalDismiss}
          status={status}
          message={message}
          title={title}
        />
      );
    },
    [onTxModalPresent, onTxModalDismiss]
  );

  const showTxModal = useCallback(
    (
      status?: txStatus,
      options?: {
        message?: string;
        title?: string;
      }
    ) => {
      // console.log("showTxModal status options", status, options);
      if (status) {
        open({ status, message: options?.message, title: options?.title });
      } else {
        open({ status: "pending" });
      }
    },
    [open]
  );
  return showTxModal;
}
